export default "__VITE_ASSET__IOUxc5Hk__"